var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergopromLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 80,
    viewBox: "0 0 300 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_486_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2889 40.5506C59.3054 35.435 55.6221 33.3821 51.9305 33.3821C50.5483 33.3821 49.166 33.647 47.9741 34.185V37.9348C48.777 37.3968 50.0848 37.0325 51.3015 37.0325C52.899 37.0491 54.2812 37.5044 54.7944 38.9944H49.9109V41.9329H54.8275C54.2647 43.2574 52.9238 43.7623 51.3098 43.7623C50.0185 43.7623 48.719 43.456 47.9658 42.8187V46.643C49.1577 47.181 50.4821 47.4459 51.8064 47.4459C55.6138 47.4459 59.2806 45.451 59.2806 40.5506H59.2889Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3013 42.3552H71.9613V47.1397H76.3812V33.6885H71.9613V38.473H67.3013V33.6885H62.8647V47.1397H67.3013V42.3552Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1803 37.1899V33.6885H80.9912V47.1397H91.2962V43.6052H85.436V42.0158H90.485V38.7462H85.436V37.1899H91.1803Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.847 47.1397H115.283V37.5707H120.936V33.6885H110.847V47.1397Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3521 33.6885V47.1397H99.7306V44.0273H102.661C105.508 44.0273 107.826 41.7096 107.826 38.862C107.826 36.0145 105.508 33.6968 102.661 33.6968H95.3521V33.6885ZM103.671 38.8538C103.671 39.665 103.008 40.3272 102.197 40.3272H99.7306V37.3803H102.197C103.008 37.3803 103.671 38.0425 103.671 38.8538Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.907 37.579H149.534V47.148H153.954V33.6968H140.495V47.148H144.907V37.579Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.294 39.5739L194.544 33.6968H190.613V47.148H194.933V40.9812L197.143 44.4164H199.469L201.679 40.9977V47.148H206V33.6968H202.06L198.294 39.5739Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.575 33.6968H158.266V47.148H162.645V44.0356H165.575C168.422 44.0356 170.74 41.7179 170.74 38.8703C170.74 36.0228 168.422 33.7051 165.575 33.7051V33.6968ZM165.111 40.3355H162.645V37.3886H165.111C165.922 37.3886 166.585 38.0508 166.585 38.8621C166.585 39.6733 165.922 40.3355 165.111 40.3355Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.333 47.628C184.306 47.628 187.534 44.3997 187.534 40.4264C187.534 36.4531 184.306 33.2166 180.333 33.2166C176.36 33.2166 173.124 36.4531 173.124 40.4264C173.124 44.3997 176.36 47.628 180.333 47.628ZM180.333 37.2726C182.005 37.2726 183.362 38.6881 183.362 40.4264C183.362 42.1647 182.005 43.572 180.333 43.572C178.661 43.572 177.303 42.1565 177.303 40.4264C177.303 38.6964 178.661 37.2726 180.333 37.2726Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.859 47.6197C133.832 47.6197 137.06 44.3914 137.06 40.4181C137.06 36.4448 133.832 33.2083 129.859 33.2083C125.886 33.2083 122.65 36.4448 122.65 40.4181C122.65 44.3914 125.886 47.6197 129.859 47.6197ZM129.859 37.2643C131.531 37.2643 132.889 38.6798 132.889 40.4181C132.889 42.1564 131.531 43.5637 129.859 43.5637C128.187 43.5637 126.83 42.1482 126.83 40.4181C126.83 38.6881 128.187 37.2643 129.859 37.2643Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0066 24.5H0V55.5H30.9977V29.4915L26.0066 24.5Z",
    fill: "#283581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 47.5782L16.7363 30.791H7.92944L0 38.7211V47.5782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90761 55.4999L23.7386 41.6265H14.1951L0.322754 55.4999H9.90761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1855 42.6365H30.9978V36.5276H19.294L13.1855 42.6365Z",
    fill: "#5DC5EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_486_618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 31,
    fill: "white",
    transform: "translate(0 24.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergopromLogo);
export default __webpack_public_path__ + "static/media/energoprom_logo.1e08753bd1541462c5087557207ea865.svg";
export { ForwardRef as ReactComponent };